<template>
  <div class="container">
    <v-card>
      <v-card-title>Stock de Bins por Planta</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="stockFacilityListHeaders"
          :items="stockFacilityListBody"
          class="elevation-1"
          no-data-text="No hay datos"
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Stock de Bins 1000L por Proveedor </v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="stockProvider1000ListHeaders"
          :items="stockProvider1000ListBody"
          class="elevation-1"
          no-data-text="No hay datos"
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Stock de Bins 800L por Proveedor</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="stockProvider800ListHeaders"
          :items="stockProvider800ListBody"
          class="elevation-1"
          no-data-text="No hay datos"
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Stock de Bins por Condición</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="stockStateListHeaders"
          :items="stockStateListBody"
          class="elevation-1"
          no-data-text="No hay datos"
        >
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>Días Fuera de Planta</v-card-title>
      <v-card-text>
        <v-data-table 
          :headers="daysOutListHeaders"
          :items="daysOutListBody"
          class="elevation-1"
          no-data-text="No hay datos"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    props: {
      source: String,
    },
    data: () => ({
      isLoading: false,
      stockFacilityListHeaders: [],
      stockFacilityListBody: [],
      stockProvider1000ListHeaders: [],
      stockProvider1000ListBody: [],
      stockProvider800ListHeaders: [],
      stockProvider800ListBody: [],
      stockStateListHeaders: [],
      stockStateListBody: [],
      daysOutListHeaders: [],
      daysOutListBody: [],
    }),
    mounted() {
      this.loadFacilityStockReport();
      this.loadProviderStockReport();
      this.loadStateStockReport();
      this.loadDaysOutReport();
    },
    methods:{
      async loadFacilityStockReport(){
        let url = `${this.base_url}bins/report/facility/null`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.stockFacilityListHeaders = response.data.data.headers;
          this.stockFacilityListBody = response.data.data.body;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadProviderStockReport(){
        let url1 = `${this.base_url}bins/report/provider/0/1`;
        await this.axios.get(url1, this.headers).then((response)=>{
          this.stockProvider1000ListHeaders = response.data.data.headers;
          this.stockProvider1000ListBody = response.data.data.body;
        }).catch((error)=>{
            console.log(error);
        });
        let url2 = `${this.base_url}bins/report/provider/0/2`;
        await this.axios.get(url2, this.headers).then((response)=>{
          this.stockProvider800ListHeaders = response.data.data.headers;
          this.stockProvider800ListBody = response.data.data.body;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadStateStockReport(){
        let url = `${this.base_url}bins/report/state`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.stockStateListHeaders = response.data.data.headers;
          this.stockStateListBody = response.data.data.body;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadDaysOutReport(){
        let url = `${this.base_url}bins/report/daysout`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.daysOutListHeaders = response.data.data.headers;
          this.daysOutListBody = response.data.data.body;
        }).catch((error)=>{
            console.log(error);
        });
      },
      ...mapMutations(['actualizarBaseUrl']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers'])
    },
    components:{
      
    }
  }
</script>